import Template from 'backbone/platform/templates/assets/assets_view_options.js.hamlc'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class AssetsViewOptionsView extends Backbone.View
  events:
    "click #tile-view" : "toggleView"
    "click #list-view" : "toggleView"

  initialize: (options) ->
    @activeView = options.activeView || "tile-view"
    @dispatcher = BackboneDispatcher.get_instance()

  render: ->
    @$el.html @template
    @$("##{@activeView}").addClass("active")
    this

  toggleView: (e) ->
    @dispatcher.trigger("toggleAssetsView", e.currentTarget.id)



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/assets_view_options_view.js.coffee